// FAQPage.tsx
import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../../../components/material-icon";
import useIsMobile from "../../../../hooks/useIsMobile";
import { colorPalette } from "../../../../utils/theme";
import { StyledContainer } from "../../knowledge-hub.styles";
import { HeaderContainer, Title, FormSection } from "./faq-page.styles";
import FAQS, { FAQItem } from "../../components/faqs/faqs";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import MoreQuestionsBanner from "../../components/more-questions-banner/more-questions-banner";
import { useEffect, useRef, useState } from "react";
import { FAQ_CATEGORIES } from "../../components/faq-categories/faq-categories";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

const faqs = (t: TFunction): FAQItem[][] => [
    [
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_1.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_1.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_2.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_2.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_3.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_3.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_4.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_4.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_5.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_5.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_6.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_6.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_7.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_7.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_8.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_8.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_9.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_9.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_1.question_10.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_1.question_10.answer")
        },
    ],
    [
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_1.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_1.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_2.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_2.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_3.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_3.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_4.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_4.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_5.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_5.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_6.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_6.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_7.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_7.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_8.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_8.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_9.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_9.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_10.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_10.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_2.question_11.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_2.question_11.answer")
        }
    ],
    [
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_1.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_1.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_2.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_2.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_3.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_3.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_4.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_4.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_5.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_5.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_6.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_6.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_7.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_7.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_8.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_8.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_9.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_9.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_3.question_10.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_3.question_10.answer")
        }
    ],
    [
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_1.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_1.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_2.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_2.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_3.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_3.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_4.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_4.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_5.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_5.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_6.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_6.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_7.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_7.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_8.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_8.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_9.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_9.answer")
        },
        {
            question: t("pages.knowledge_hub.faq_categories.faq_category_4.question_10.question"),
            answer: t("pages.knowledge_hub.faq_categories.faq_category_4.question_10.answer")
        }
    ]
];


const FAQPage = () => {
    const navigate = useCustomNavigate();
    const isMobile = useIsMobile();
    const location = useLocation();
    const { t } = useTranslation();

    // States
    const [expandedCategory, setExpandedCategory] = useState<number | null>(null);

    // References for each category
    const faqRefs = useRef<Map<number, HTMLDivElement | null>>(new Map());

    // Effects
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const category = searchParams.get("categoryId");

        if (category) {
            const categoryId = Number(category);
            setExpandedCategory(categoryId);

            // TODO: Find different solution to prevent issue that the status bar is scrolling up to.
            /*setTimeout(() => {
                const targetRef = faqRefs.current.get(categoryId);
                if (targetRef) {
                    targetRef.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 200);*/
        }
    }, [location.search]);

    return (
        <StyledContainer>
            <Row className="justify-content-center">
                <Col xs={12} lg={10} xl={9}>
                    <Row>
                        <Col xs={12}>
                            <HeaderContainer>
                                {!isMobile && (
                                    <MaterialIcon
                                        icon="arrow_back"
                                        size={24}
                                        color={colorPalette.textMain}
                                        onClick={() => navigate(-1)}
                                    />
                                )}
                                <Title>{t("pages.knowledge_hub.faq_categories.title")}</Title>
                            </HeaderContainer>

                            <FormSection className="gy-3">
                                <Col xs={12}>
                                    {faqs(t).map((faqCategory, index) => (
                                        <div
                                            ref={el => {
                                                faqRefs.current.set(FAQ_CATEGORIES(t)[index].id, el);
                                            }}
                                            key={FAQ_CATEGORIES(t)[index].id}
                                        >
                                            <FAQS
                                                faqCategory={FAQ_CATEGORIES(t)[index]}
                                                faqs={faqCategory}
                                                showButton
                                                isExpanded={expandedCategory === FAQ_CATEGORIES(t)[index].id}
                                            />
                                        </div>
                                    ))}
                                </Col>
                            </FormSection>
                        </Col>
                    </Row>

                    <MoreQuestionsBanner />
                </Col>
            </Row>
        </StyledContainer>
    );
};

export default FAQPage;
